import { Buffer } from 'buffer';
window.Buffer = Buffer;
(window as any)['global'] = window
